// Lib
import React from 'react';

// Components
import TrashLoadMoreButton from './TrashLoadMoreButton';
import OrchestratedList from '../../../../../list/OrchestratedList';
import TrashElementList from './TrashElementList';

// Hooks
import useElementListPlaceholdersInitialisation from '../../../../../element/elementPlaceholder/useElementListPlaceholdersInitialisation';

// Types
import { TrashListOrderedContent } from './trashElementTypes';

const INITIAL_RENDER_SIZE = 10;

type TrashTabContentProps = {
    trashListContentIds: string[];
    currentBoardId: string;
    trashListOrderedContent: TrashListOrderedContent;
    hasMore: boolean;
    dispatchLoadMoreTrash: () => void;
};

const TrashTabContent = (props: TrashTabContentProps) => {
    const { trashListContentIds } = props;
    const [isContentFullyRendered, setIsContentFullyRendered] = React.useState(false);

    useElementListPlaceholdersInitialisation(trashListContentIds);

    return (
        <div className="TrashTabContent">
            <OrchestratedList
                childElementIds={trashListContentIds}
                initialRenderSize={INITIAL_RENDER_SIZE}
                renderIncrement={10}
                batchRenderAdditionalContent={true}
                onOrchestrationStart={() => setIsContentFullyRendered(false)}
                onOrchestrationEnd={() => setIsContentFullyRendered(true)}
            >
                {(childElementIds: string[]) => <TrashElementList {...props} childElementIds={childElementIds} />}
            </OrchestratedList>
            <TrashLoadMoreButton {...props} isContentFullyRendered={isContentFullyRendered} />
        </div>
    );
};

export default TrashTabContent;
